import "./patronProfile.css";
import profileImg from "./assets/profileImg.svg";
import rectangleImg from "./assets/rectangleImg.svg";
import tick from "./assets/tick.svg";
import { useEffect, useState } from "react";
import Patron_Navbar from "../Patron_Navbar";
import { toast } from "react-toastify";
import {
  makeAuthenticatedGETRequest,
  makeAuthenticatedPATCHRequest,
  makeAuthenticated_Multi_Patch_REQ,
} from "../../services/serverHelper";
import { patronProfilePoints } from "../../services/apis";
import { useSelector } from "react-redux";
import PatronSidebar from "../PatronSidebar";

const name = "Patron Name";
const profession = "Patron Profession";

// Define the base URL for uploaded images (CHANGE 5000 to your backend port, e.g., 8000; adjust /uploads/ if path differs)
// const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'http://localhost:5000/uploads/';

function PatronProfile() {
  const { accessToken } = useSelector((state) => state.auth);
  const [avatarSrc, setAvatarSrc] = useState('');

  const indianStates = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'];

  const citiesByState = {
    'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool'],
    'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Tawang', 'Pasighat', 'Ziro'],
    'Assam': ['Guwahati', 'Jorhat', 'Dibrugarh', 'Silchar', 'Nagaon'],
    'Bihar': ['Patna', 'Gaya', 'Muzaffarpur', 'Bhagalpur', 'Darbhanga'],
    'Chhattisgarh': ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Raigarh'],
    'Goa': ['Panaji', 'Vasco da Gama', 'Margao', 'Mapusa', 'Ponda'],
    'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar'],
    'Haryana': ['Faridabad', 'Gurugram', 'Rohtak', 'Panipat', 'Karnal'],
    'Himachal Pradesh': ['Shimla', 'Mandi', 'Solan', 'Dharamshala', 'Kullu'],
    'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh'],
    'Karnataka': ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum'],
    'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam'],
    'Madhya Pradesh': ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain'],
    'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Aurangabad'],
    'Manipur': ['Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Kakching'],
    'Meghalaya': ['Shillong', 'Tura', 'Jowai', 'Nongpoh', 'Williamnagar'],
    'Mizoram': ['Aizawl', 'Lunglei', 'Champhai', 'Saiha', 'Kolasib'],
    'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha'],
    'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur'],
    'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda'],
    'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Bikaner'],
    'Sikkim': ['Gangtok', 'Namchi', 'Mangan', 'Singtam', 'Gyalshing'],
    'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem'],
    'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam'],
    'Tripura': ['Agartala', 'Dharmanagar', 'Udaipur', 'Kailashahar', 'Belonia'],
    'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Allahabad'],
    'Uttarakhand': ['Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur'],
    'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri'],
  };
  


  const [formData, setFormData] = useState({
    personalInfo: {
      profession: "",
      companyName: "",
      authorizedPerson: "",
      designation: "",
      companyDescription: "",
      firstName: "",
      lastName: "",
      avatar: null, // Initialize avatar as null
    },
    address: {
      state: "",
      city: "",
      pincode: "",
      // details: "",
    },
    contactDetails: {
      email: "",
      contactNumber: "",
      website: "",
      expectations: "",
    },
  });




  const calculateProgressPercentage = () => {
  const isFilled = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string" && value.trim() !== "") return true;
    if (typeof value === "number" && value !== 0) return true;
    if (Array.isArray(value) && value.length > 0) return true;
    if (typeof value === "boolean" && value === true) return true;
    return false;
  };

  const countFields = (obj) => {
    let total = 0;
    let filled = 0;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          const nestedCounts = countFields(value);
          total += nestedCounts.total;
          filled += nestedCounts.filled;
        } else {
          total++;
          if (isFilled(value)) filled++;
        }
      }
    }
    return { total, filled };
  };

  const { total, filled } = countFields(formData);
  const percentage = total > 0 ? Math.round((filled / total) * 100) : 0;
  return percentage;
};

  const fetchPatronProfileData = async () => {
    try {
      const response = await makeAuthenticatedGETRequest(
        `${patronProfilePoints.FETCH_PATRON_APPLI_API}/${localStorage.getItem("artId")}`,
        accessToken
      );
      console.log("res", response.data);
      if (response.status === "success") {
        setFormData(response.data);
        setAvatarSrc(response.data.personalInfo?.avatar?.url || profileImg);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong , please try again");
    }
  };


const [count, setCount] = useState(0);
const [rotation, setRotation] = useState(0);

// Add this useEffect to calculate progress
useEffect(() => {
  const newProgress = calculateProgressPercentage();
  setCount(newProgress);
  const rotationValue = Math.min((newProgress / 100) * 360, 360);
  setRotation(rotationValue);
}, [formData]);

  useEffect(() => {
    fetchPatronProfileData();
  }, []);

  // this is to update the   profile
  const submitHandler = async (event) => {
    event.preventDefault();
    const toastId = toast.loading("Loading...");
    console.log(formData)
    try {
      const { personalInfo, address, contactDetails } = formData;
      const dataToSend = { personalInfo, address, contactDetails };
      console.log(dataToSend)
      const response = await makeAuthenticatedPATCHRequest(
        `${patronProfilePoints.FETCH_PATRON_APPLI_API}/${localStorage.getItem("artId")}`,
        dataToSend,
        accessToken
      );
      console.log("respnse", response);
      if (response.status === "success") {
        toast.success("successfully updated");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong , please try again");
    }
    toast.dismiss(toastId);
  };

  const getFullImageUrl = (imageValue) => {
    if (!imageValue) return "/default-avatar.png";

    try {
      let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
      if (!raw) return "/default-avatar.png";

      // blob URL (local preview)
      if (raw.startsWith("blob:")) return raw;

      // If string contains absolute URL anywhere (sometimes backend returns weird concatenation), extract first http(s)
      const absMatch = raw.match(/https?:\/\/[^\s]+/i);
      if (absMatch && absMatch[0]) {
        // return absolute URL directly (preserve)
        return absMatch[0];
      }

      // protocol-relative
      if (raw.startsWith("//")) return "https:" + raw;

      // strip leading slashes and common prefixes
      let cleaned = raw
        .replace(/^\/+/, "")
        .replace(/^public\/images\//i, "")
        .replace(/^public\/uploads\//i, "")
        .replace(/^uploads\/performance\//i, "")
        .replace(/^uploads\//i, "")
        .replace(/^images\//i, "")
        .replace(/^api\/v1\/images\//i, "")
        .replace(/^api\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
        .trim();

      // Build host from env or default
      const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
      // Ensure we keep only host (strip any /api/v1 etc)
      let API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/i, "");
      if (!API_HOST.startsWith("http")) {
        API_HOST = "https://" + API_HOST;
      }

      // Use /images/<filename> endpoint which your backend serves
      return `${API_HOST}/images/${cleaned}`;
    } catch (err) {
      console.error("getFullImageUrl error:", err, imageValue);
      return "/default-avatar.png";
    }
  };


  // change handler for input data
  // const changeHandler = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const changeHandler = (event) => {
    const { name, value } = event.target;
    const [section, property] = name.split("."); // Split the name into section and property
  
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section], // Keep the previous state of the section
        [property]: value, // Update the property within the section
      },
    }));
    console.log(formData)
  };

  // Compute the avatar source dynamically: handle both string URL and {url: string} object, prepend base URL if needed, fallback to placeholder

  // this is to add avatar file
  const handleButtonClick = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".jpg, .jpeg, .png";
    fileInput.onchange = handleFileChange;
    fileInput.click();
  };

  // this is to add the avatar
  const handleFileChange = async (event) => {
    const toastId = toast.loading("Loading...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      console.log("sele", selectedFile);

      const uploadFormData = new FormData();
      uploadFormData.append("avatar", selectedFile);

      try {
        const response = await makeAuthenticated_Multi_Patch_REQ(
          patronProfilePoints.PATRON_AVATAR_UPDATE,
          uploadFormData,
          accessToken
        );
        console.log("Upload res", response);
        
        // Extract the new avatar URL (assuming response.data.avatar is the URL string or {url: string})
        let newAvatar;
        if (response?.data?.avatar) {
          if (typeof response.data.avatar === 'string') {
            newAvatar = response.data.avatar; // Set as string
          } else if (response.data.avatar.url) {
            newAvatar = { url: response.data.avatar.url }; // Set as object
          } else {
            newAvatar = response.data.avatar; // Set as is
          }
        }
        
        // Update local state immediately with the new avatar
        setFormData(prev => ({
          ...prev,
          personalInfo: {
            ...prev.personalInfo,
            avatar: newAvatar
          }
        }));
        
        console.log("Updated avatar in state:", newAvatar);
        toast.success("Successfully Updated Profile Picture");
      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Failed to upload profile picture. Please try again.");
      }
    }
    toast.dismiss(toastId);
  };

return (
  <>
    <Patron_Navbar />
    <div className="dashboard-layout">
      <PatronSidebar />
    
      <div className="patronProfile_wrapper">
        {/* actual navbar */}

        <section className="patronProfile_container">
          <img src={rectangleImg} alt="" className="rectangleImg" />
          
          {/* Container starts here */}
          <div className="patron_img_name_container">
            <div
              className="profileImg"
              style={{
                background: `conic-gradient(#AD2F3B ${rotation}deg, #d9d9d9 0deg)`,
                padding: 0,
                width: "220px",
                height: "220px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                position: "relative",
              }}
            >
              <img
                loading="lazy"
                  src={getFullImageUrl(avatarSrc || "")}
                  alt="Profile avatar"
                  onError={(e) => {
                    console.error("Avatar load failed:", e.target.src);
                    try {
                      // try fallback: construct from original value
                      const fallback = getFullImageUrl(avatarSrc || "");
                      if (fallback && fallback !== e.target.src) {
                        e.target.onerror = null;
                        e.target.src = fallback;
                        return;
                      }
                      // try decode %40 -> @ fallback
                      if (e.target.src.includes("%40")) {
                        e.target.onerror = null;
                        e.target.src = e.target.src.replace(/%40/g, "@");
                        return;
                      }
                    } catch (err) {
                      console.warn("avatar fallback error", err);
                    }
                    e.target.onerror = null;
                    e.target.src = "/default-avatar.png";
                  }}
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  // transform removed from here
                }}
              />
              <div
                className="progressBar"
                style={{
                  transform: `rotate(${rotation}deg) translate(0px, -110px) rotate(-${rotation}deg)`,
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#AD2F3B",
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  margin: "auto",
                  overflow: "hidden",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                }}
              >
                {count}%
              </div>
            </div>

            <div className="verify_name_wrapper">
              <p className="patron_name">
                {formData?.personalInfo?.firstName}{" "}
                {formData?.personalInfo?.lastName}{" "}
              </p>
              <div className="verify_container">
                <img src={tick} alt="tick" className="verifyImg" />
              </div>
            </div>

            <p className="patron_profession">
              {formData?.personalInfo?.companyName}-
              {formData?.personalInfo?.profession}
            </p>

            {/* Buttons moved INSIDE this container to be just below text */}
            <div
              className="avatar-buttons-container"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "15px",
                marginTop: "10px", // Reduced margin to keep it close
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={handleButtonClick}
                className="uploadProfileButton"
                style={{
                  // Styles kept same, just ensure width fits
                  backgroundColor: "#ad2f3b",
                  color: "white",
                  border: "none",
                  borderRadius: "15px",
                  padding: "10px 20px",
                  fontFamily: "Poppins",
                  fontWeight: "500",
                  fontSize: "16px",
                  cursor: "pointer",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Upload/Edit Profile Picture
              </button>

              <button
                onClick={async () => {
                  if (
                    window.confirm(
                      "Are you sure you want to remove your profile picture?"
                    )
                  ) {
                    try {
                      const toastId = toast.loading("Removing avatar...");
                      const response = await makeAuthenticatedPATCHRequest(
                        patronProfilePoints.PATRON_AVATAR_UPDATE,
                        { avatar: null },
                        accessToken
                      );

                      if (response.status === "success") {
                        setFormData((prev) => ({
                          ...prev,
                          personalInfo: {
                            ...prev.personalInfo,
                            avatar: null,
                          },
                        }));
                        toast.dismiss(toastId);
                        toast.success("Profile picture removed successfully");
                      } else {
                        toast.dismiss(toastId);
                        toast.error("Failed to remove profile picture");
                      }
                    } catch (error) {
                      console.error("Remove avatar error:", error);
                      toast.error("Failed to remove profile picture");
                    }
                  }
                }}
                className="removeProfileButton"
                style={{
                  backgroundColor: "#ad2f3b",
                  color: "white",
                  border: "none",
                  borderRadius: "15px",
                  padding: "10px 20px",
                  fontFamily: "Poppins",
                  fontWeight: "500",
                  fontSize: "16px",
                  cursor: "pointer",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Remove Avatar
              </button>
            </div>
          </div>

            {/* personal information  */}
            <main className="personal_information_wrapper">
              <form onSubmit={submitHandler} className="personal_info_form">
                <p className="personal_information_text">Basic Profile</p>
                <div className="personal_info_form_part">
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">First Name*</p>
                    <input
                      name="personalInfo.firstName"
                      onChange={changeHandler}
                      value={formData.personalInfo.firstName}
                      className={`personal_form_input`}
                      required
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Last Name*</p>
                    <input
                      name="personalInfo.lastName"
                      onChange={changeHandler}
                      value={formData.personalInfo.lastName}
                      className={`personal_form_input`}
                      required
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Profession</p>
                    <input
                      name="personalInfo.profession"
                      onChange={changeHandler}
                      value={formData.personalInfo.profession}
                      className={`personal_form_input`}
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Company Name</p>
                    <input
                      name="personalInfo.companyName"
                      onChange={changeHandler}
                      value={formData.personalInfo.companyName}
                      className={`personal_form_input`}
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Name of the Authorized Person</p>
                    <input
                      name="personalInfo.authorizedPerson"
                      onChange={changeHandler}
                      value={formData.personalInfo.authorizedPerson}
                      className={`personal_form_input`}
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Designation</p>
                    <input
                      name="personalInfo.designation"
                      onChange={changeHandler}
                      value={formData.personalInfo.designation}
                      className={`personal_form_input`}
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Company Description</p>
                    <textarea
                      name="personalInfo.companyDescription"
                      onChange={changeHandler}
                      value={formData.personalInfo.companyDescription}
                      style={{ height: "150px", resize: "none" }}
                      className={`personal_form_input  "aboutUs_input `}
                    />
                  </label>
                </div>
                <p className="personal_information_text">Address</p>
                <div className="personal_info_form_part">

                <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Pincode*</p>
                    <input
                      name="address.pincode"
                      maxLength={6}
                      pattern="[0-9]{6}"
                      onChange={changeHandler}
                      value={formData.address.pincode}
                      className={`personal_form_input`}
                      required
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">state*</p>
                    {/* <input
                      name="address.state"
                      onChange={changeHandler}
                      value={formData.address.state}
                      className={`personal_form_input`}
                    /> */}
                    <select
                      style={{ backgroundColor: "White", color: "black" }}
                      name="address.state"
                      onChange={changeHandler}
                      value={formData.address.state}
                      className={`personal_form_input`}
                      required
                    >
                      {indianStates.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">City*</p>
                    {/* <input
                      name="address.city"
                      onChange={changeHandler}
                      value={formData.address.city}
                      className={`personal_form_input`}
                    /> */}
                    <select
                      style={{ backgroundColor: "White", color: "black" }}
                      name="address.city"
                      onChange={changeHandler}
                      value={formData.address.city}
                      className={`personal_form_input`}
                      required
                    >
                      {formData.address.state &&
                        citiesByState[formData.address.state] &&
                        citiesByState[formData.address.state].map((city) => (
                          <option key={city} value={city}>
                            {city}
                          </option>
                        ))}
                    </select>
                  </label>
            
                  {/* <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Detailed Address</p>
                    <textarea
                      name="address.details"
                      onChange={changeHandler}
                      value={formData.address.details}
                      style={{ height: "150px", resize: "none" }}
                      className={`personal_form_input  "aboutUs_input `}
                    />
                  </label> */}
                </div>
                <p className="personal_information_text">Contact</p>
                <div className="personal_info_form_part">
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Company Email*</p>
                    <input
                      name="contactDetails.email"
                      onChange={changeHandler}
                      value={formData.contactDetails?.email}
                      className={`personal_form_input`}
                      required
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Contact Number*</p>
                    <input
                      type="tel"
                      name="contactDetails.contactNumber"
                      onChange={changeHandler}
                      value={formData?.contactDetails?.contactNumber}
                      className={`personal_form_input`}
                      required
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Website</p>
                    <input
                      name="contactDetails.website"
                      type="url"
                      onChange={changeHandler}
                      value={formData?.contactDetails?.website}
                      className={`personal_form_input`}
                    />
                  </label>
                  <label htmlFor="" className="single_personal_info">
                    <p className="form_title">Expectation from eKalakaar</p>
                    <input
                      name="contactDetails.expectations"
                      onChange={changeHandler}
                      value={formData?.expectations}
                      className={`personal_form_input`}
                    />
                  </label>
                </div>

                <button type="submit" className="updateButton">
                  Update
                </button>
              </form>
            </main>
          </section>
        </div>
      </div>
  </>
  );
}

export default PatronProfile;